import { render, staticRenderFns } from "./CommentEdit.vue?vue&type=template&id=942b32b2&scoped=true"
import script from "./CommentEdit.vue?vue&type=script&lang=js"
export * from "./CommentEdit.vue?vue&type=script&lang=js"
import style0 from "./CommentEdit.vue?vue&type=style&index=0&id=942b32b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "942b32b2",
  null
  
)

export default component.exports